import { supabase } from '@/integrations/supabase/client';

interface LogErrorParams {
  errorCode?: string;
  errorMessage: string;
  errorSource: 'gemini' | 'stripe' | 'edge_function' | 'auth' | 'taddy' | 'youtube' | 'unknown';
  metadata?: Record<string, unknown>;
}

/**
 * Logs a critical error to the error_logs table for observability.
 * This should only be called for service-level errors that affect user experience,
 * NOT for expected business logic (e.g., NO_CREDITS) or user input errors.
 */
export async function logCriticalError({
  errorCode,
  errorMessage,
  errorSource,
  metadata = {},
}: LogErrorParams): Promise<void> {
  try {
    // Get current user info (may be null for anonymous users)
    const { data: { user } } = await supabase.auth.getUser();
    
    // Get current URL
    const url = window.location.pathname + window.location.search;
    
    // Add browser info to metadata
    const enrichedMetadata = {
      ...metadata,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    await supabase.functions.invoke('log-error', {
      body: {
        error_code: errorCode,
        error_message: errorMessage,
        error_source: errorSource,
        url,
        user_id: user?.id || null,
        metadata: enrichedMetadata,
        client_platform: 'web',
      },
    });
  } catch {
    // Silently fail - we don't want error logging to cause more errors
  }
}
